import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import axios from '../../../axios/axios';
import logo from '../../../assets/images/welsend-logo.jpg';
import DownloadFile from './DownloadFile';
import Loader from '../loader/loader';
import { translateStaticContent } from '../../../helpers/translateStaticContent';

class AboutSystem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            text: '',
            downloadFiles: [],
            loading: false
        }
    }

    componentDidMount() {
        this.getSystemInfo();
    }

    componentDidUpdate(prevProps) {
        if (this.props.activeLang !== prevProps.activeLang) {
            this.getSystemInfo();
        }
    }
 
    getSystemInfo = () => {
        axios.defaults.headers.isocode = this.props.activeLang ? this.props.activeLang : 'uk';
        this.setState({...this.state, loading: true }, () => {
            axios.get(`/api/welsend/public/systemInfos`)
            .then(res => res.data)
            .then(info => {
                this.setState({...this.state,  text: info.text, loading: false})  
            })
            .catch((error =>  {
                console.log(error);
            }))
        })

        axios.get(`/api/welsend/public/systemInfoFiles/metadata`)
        .then(res => res.data)
        .then(metadata => {
            this.listFilesForDownload(metadata);
        })
        .catch((error =>  {
            console.log(error);
        }))
    }
    
    listFilesForDownload = (data) => {
        const downloadFilesSort = this.sortByID(data);
        const downloadFiles = downloadFilesSort.map(item => {
            return <DownloadFile data={item} key={item.id}/>
        })
        this.setState({...this.state, downloadFiles: downloadFiles})
    }

    createMarkupText = () => {
        return {__html: this.state.text ? this.state.text : ''};
    }

    sortByID = (documents) => {
        return documents.sort((a, b) => a.id < b.id ? 1 : -1);
    }

    render() {
        return (
             <div className="container about-system">
                 <h1>
                    {translateStaticContent('aboutSystemHeading', 
                        this.props.defaultStaticContentAboutSystem, this.props.activeLangStaticContentAboutSystem)}
                 </h1>
                 {this.state.loading ? <Loader /> :
                    <div>
                        <div className="info">
                            <div className="main-logo">
                                <img src={logo} referrerPolicy="no-referrer"/>
                            </div>
                            <div dangerouslySetInnerHTML={this.createMarkupText()} />
                        </div>
                        <div className="downloads-section">
                            {this.state.downloadFiles.length > 0 ? this.state.downloadFiles : ''}
                        </div>
                        <div id='link'></div>
                    </div>
                }
            </div>
        )
    }
}

const mapStateToProps = state => ({
    activeLang: state.lang.activeLang
})

export default connect(mapStateToProps)(AboutSystem);
  
AboutSystem.propTypes = {
    activeLang: PropTypes.string.isRequired,
    defaultStaticContentAboutSystem: PropTypes.object,
    activeLangStaticContentAboutSystem: PropTypes.object,
}